module.exports = __webpack_public_path__ + "img/small-4.703cf65b.jpg";